var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 46,
    viewBox: "0 0 182 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.8506 32.5581C34.7113 40.207 27.7751 45.9752 18.9583 45.9752C7.41908 45.9755 0.09375 37.0961 0.09375 27.3088C0.09375 16.8734 8.06756 8.64233 18.6342 8.64233C27.0619 8.64233 34.6469 13.8273 36.8506 22.318H29.9141C28.0992 17.5868 23.6908 14.9298 18.8939 14.9298C15.3281 14.8647 12.735 16.0309 10.2716 18.3646C8.19704 20.4387 6.8357 23.7441 6.8357 27.3091C6.8357 34.5682 12.1516 39.6884 18.8939 39.6884C24.7931 39.6233 28.488 36.0594 29.9141 32.5584H36.8506V32.5581Z",
    fill: "#FF7B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.3285 44.8062H72.855V38.8934C70.4898 43.4371 65.6349 45.8018 60.2817 45.8018C49.3885 45.8018 42.915 37.3378 42.915 27.8787C42.915 17.5481 50.4466 9.95557 60.2817 9.95557C67.0039 9.95557 71.2991 13.6901 72.855 16.9255V10.9515H79.3285V44.8062ZM49.3885 28.0039C49.4505 33.0443 52.9989 39.7651 61.2152 39.7651C66.3815 39.7651 70.0538 36.902 71.7347 33.0443C72.4817 31.4887 72.8553 29.7456 72.9176 28.0039C72.9795 26.2608 72.6685 24.5184 71.9215 22.9618C70.303 19.0415 66.5061 15.9926 61.0903 15.9926C53.9947 15.9926 49.3882 21.5937 49.3882 27.9413V28.0039H49.3885Z",
    fill: "#FF7B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M87.9883 0H94.5508V24.9947L107.507 11.9195H115.171L100.451 26.4539L115.597 45.0025H108.237L94.5508 27.9739V45.0021H87.9883V0Z",
    fill: "#FF7B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M165.571 11.922H171.532V16.7872C173.418 12.895 176.885 10.3066 181.386 10.2454V16.5705H180.96C175.174 16.9054 171.897 20.5569 171.897 27.1254V45.0045H165.571V11.922H165.571Z",
    fill: "#FF7B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M156.423 23.2272H122.46V17.5758L132.101 14.6338L156.423 17.5758V23.2272Z",
    fill: "#FF7B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M156.423 28.1094H122.46V33.6676H156.423V28.1094Z",
    fill: "#FF7B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M156.423 38.55H122.46V44.1083H156.423V38.55Z",
    fill: "#FF7B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M139.5 11.6497C141.517 11.6497 143.153 10.0143 143.153 7.99707C143.153 5.9798 141.517 4.34448 139.5 4.34448C137.482 4.34448 135.846 5.9798 135.846 7.99707C135.846 10.0143 137.482 11.6497 139.5 11.6497Z",
    fill: "#FF7B72"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingLogo);
export default __webpack_public_path__ + "static/media/LoadingLogo.9e392fadf342162a9a4e5d03431e00c5.svg";
export { ForwardRef as ReactComponent };